
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"data-name":"Path 573","d":"M4.798 14.999h-2.74a2.061 2.061 0 0 1-2.06-2.062v-2.744a2.061 2.061 0 0 1 2.06-2.056h2.74a2.061 2.061 0 0 1 2.058 2.058v2.744a2.061 2.061 0 0 1-2.058 2.06zM2.053 9.51a.687.687 0 0 0-.686.686v2.744a.686.686 0 0 0 .686.686h2.745a.686.686 0 0 0 .686-.686v-2.744a.687.687 0 0 0-.686-.686z"}}),_c('path',{attrs:{"data-name":"Path 574","d":"M12.937 14.999h-2.74a2.061 2.061 0 0 1-2.06-2.062v-2.744a2.061 2.061 0 0 1 2.06-2.056h2.74a2.061 2.061 0 0 1 2.058 2.058v2.744a2.061 2.061 0 0 1-2.058 2.06zM10.193 9.51a.687.687 0 0 0-.686.686v2.744a.686.686 0 0 0 .686.686h2.744a.686.686 0 0 0 .686-.686v-2.744a.687.687 0 0 0-.686-.686z"}}),_c('path',{attrs:{"data-name":"Path 575","d":"M4.798 6.861h-2.74a2.061 2.061 0 0 1-2.06-2.062V2.055a2.061 2.061 0 0 1 2.06-2.056h2.74a2.061 2.061 0 0 1 2.058 2.058v2.744a2.061 2.061 0 0 1-2.058 2.06zM2.053 1.372a.686.686 0 0 0-.686.686v2.744a.687.687 0 0 0 .686.686h2.745a.686.686 0 0 0 .686-.686V2.058a.686.686 0 0 0-.686-.686z"}}),_c('path',{attrs:{"data-name":"Path 576","d":"M12.937 6.861h-2.74a2.061 2.061 0 0 1-2.06-2.062V2.055a2.061 2.061 0 0 1 2.06-2.056h2.74a2.061 2.061 0 0 1 2.058 2.058v2.744a2.061 2.061 0 0 1-2.058 2.06zm-2.744-5.489a.686.686 0 0 0-.686.686v2.744a.686.686 0 0 0 .686.686h2.744a.687.687 0 0 0 .686-.686V2.058a.686.686 0 0 0-.686-.686z"}})])])
          )
        }
      }
    